module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/assessment_achievements/2@2x_7609585875cbde6295790962c172ee79.png";